import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Save forum question
export const saveForumQuestion = createAsyncThunk(
  "question/saveForumQuestion",
  async ({ user_id, question, category }, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.SUBMIT_FORUM_QUESTION, {
        user_id,
        question,
        category,
      });

      return {
        message: response.data?.message || "Question submitted successfully!",
      };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

// Load forum data
export const loadForumData = createAsyncThunk(
  "question/loadForumData",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await agent.get(
        `${API.FORUM_DATA_FETCH}/${userId}`
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

const questionSlice = createSlice({
  name: "question",
  initialState: {
    forumData: [],
    status: "idle",
    saving: false,
    success: null,
    error: null,
  },
  reducers: {
    clearQuestionStatus(state) {
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Save Question
      .addCase(saveForumQuestion.pending, (state) => {
        state.saving = true;
        state.success = null;
        state.error = null;
      })
      .addCase(saveForumQuestion.fulfilled, (state, action) => {
        state.saving = false;
        state.success = action.payload.message;
      })
      .addCase(saveForumQuestion.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })

      // Load Forum Data
      .addCase(loadForumData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadForumData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.forumData = action.payload;
      })
      .addCase(loadForumData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearQuestionStatus } = questionSlice.actions;
export default questionSlice.reducer;
